import { CellProps } from 'react-table'
import { FuncionarioList } from '../../core/_models'
import { FuncionarioActionsCell } from './FuncionarioActionsCell'
import {
  PlainHeader,
  SelectionCell,
  SelectionHeader,
  sortableColumn,
  StackedCell,
  StatusBadge,
  TableColumn,
} from '../../../../../../components'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useListView } from '../../core/ListViewProvider'
import { formatDocumentoPrincipal } from '../../../../../../../_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'

const FuncionarioColumns = (t: TFunction): ReadonlyArray<TableColumn<FuncionarioList>> => [
  {
    Header: (props) => (
      <SelectionHeader
        useListView={useListView}
        tableProps={props}
        ariaLabel='Selecionar todos desta página'
      />
    ),
    id: 'selection',
    cellWidth: '48px',
    Cell: ({ row }: CellProps<FuncionarioList>) => (
      <SelectionCell
        useListView={useListView}
        id={row.original.id}
        ariaLabel={`Selecionar ${row.original.pessoa?.nome ?? ''}`}
      />
    ),
  },
  sortableColumn<FuncionarioList>({
    id: 'pessoa.nome',
    useQueryRequest,
    fields: [
      { field: 'pessoa.nome', label: t('cols.nome') },
      { field: 'pessoa.cpf', label: t('cols.documento'), sortable: false },
    ],
    Cell: ({ row }: CellProps<FuncionarioList>) => (
      <StackedCell
        tabular
        primary={row.original.pessoa?.nome}
        secondary={formatDocumentoPrincipal(row.original.pessoa?.documentos)}
      />
    ),
  }),
  sortableColumn<FuncionarioList>({
    id: 'cargo',
    cellWidth: '160px',
    useQueryRequest,
    fields: [{ field: 'cargo', label: t('cols.cargo') }],
    Cell: ({ row }: CellProps<FuncionarioList>) => (
      <StackedCell primary={row.original.cargoDescricao} />
    ),
  }),
  sortableColumn<FuncionarioList>({
    id: 'empresa.nomeFantasia',
    cellWidth: '220px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'empresa.nomeFantasia', label: t('empresa.label') }],
    Cell: ({ row }: CellProps<FuncionarioList>) => (
      <StackedCell primary={row.original.empresa?.nomeFantasia} />
    ),
  }),
  sortableColumn<FuncionarioList>({
    id: 'ativo',
    cellWidth: '112px',
    useQueryRequest,
    fields: [{ field: 'ativo', label: t('cols.status') }],
    Cell: ({ row }: CellProps<FuncionarioList>) => <StatusBadge active={row.original.ativo} />,
  }),
  {
    Header: () => <PlainHeader>{t('cols.acesso')}</PlainHeader>,
    id: 'pessoa.usuario.confirmado',
    cellWidth: '132px',
    hideOnMobile: true,
    Cell: ({ row }: CellProps<FuncionarioList>) => (
      <StatusBadge
        active={row.original.pessoa?.usuario?.confirmado}
        labels={['Validado', 'Não validado']}
      />
    ),
  },
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '132px',
    align: 'end',
    Cell: ({ row }: CellProps<FuncionarioList>) => (
      <FuncionarioActionsCell funcionario={row.original} />
    ),
  },
]

export { FuncionarioColumns }
